// ToastNotification.js
import React from "react";
import { toast, Toaster } from "react-hot-toast";

const ToastNotification = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 4000,
        style: {
          background: "#363636",
          color: "#fff",
        },
        success: {
          duration: 3000,
          style: {
            background: "green",
          },
        },
        error: {
          style: {
            background: "red",
          },
        },
      }}
    />
  );
};

// Functions to trigger different toast types
export const toastSuccess = (message) => {
  toast.success(message || "Success!");
};

export const toastError = (message) => {
  toast.error(message || "Something went wrong!");
};

export default ToastNotification;
